/* Полноэкранный адаптивный лоадер, играет один раз за сессию. */
import { useEffect, useRef, useState } from 'react';

export default function FedLoader() {
  const [visible, setVisible] = useState(() => {
    try { return sessionStorage.getItem('fedLoaderSeen') !== '1'; } catch (e) { return true; }
  });
  const [done, setDone] = useState(false);
  const timer = useRef(null);
  const DURATION = 3000;

  useEffect(() => {
    if (!visible) return;
    const finish = () => {
      setDone(true);
      try { sessionStorage.setItem('fedLoaderSeen', '1'); } catch (e) {}
      setTimeout(() => setVisible(false), 800);
    };
    timer.current = setTimeout(finish, DURATION);
    return () => clearTimeout(timer.current);
  }, [visible]);

  if (!visible) return null;

  const skip = () => {
    if (done) return;
    clearTimeout(timer.current);
    setDone(true);
    try { sessionStorage.setItem('fedLoaderSeen', '1'); } catch (e) {}
    setTimeout(() => setVisible(false), 800);
  };

  return (
    <div id="fedload" className={done ? 'done' : ''} onClick={skip}>
      <picture className="fl-art">
        <source media="(max-width: 700px)" srcSet="/assets/fed-loading-mobile.jpg" />
        <img src="/assets/fed-loading-desktop.png" alt="" />
      </picture>
      <div className="fl-scan" />
    </div>
  );
}
